<wlm-map-popup-wrapper
  [showArrowIcon]="true"
  [showSpinner]="false"
  [customTitle]="layerType"
  [subTitle]="subTitle"
  [popupWidth]="'230px'"
  (popupClose)="closePopup()"
>
  <ng-container popup-content>
    <div>
      <ng-container *ngFor="let item of model.styleDefinition.rangeDefinition; let idx = index">
        <div class="controls">
          <ng-container *ngIf="layerType === 'Point'">
            <ng-container [ngSwitch]="controlsData[idx]?.shape">
              <div
                *ngSwitchCase="'circle'"
                class="circle"
                [style.background]="controlsData[idx]?.Color"
              ></div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="layerType === 'Line'">
            <div class="line" [style.background]="controlsData[idx]?.Color"></div>
          </ng-container>
          <ng-container *ngIf="idx === 0; else notFirstInput">
            <label class="range-label">Min</label>
          </ng-container>
          <ng-template #notFirstInput>
            <input
              matInput
              class="range-input"
              type="number"
              min="0"
              [readonly]="true"
              [value]="model.styleDefinition.rangeDefinition[idx - 1]?.value"
            />
          </ng-template>

          <ng-container
            *ngIf="idx === model.styleDefinition.rangeDefinition.length - 1; else notLastInput"
          >
            <label class="range-label">Max</label>
          </ng-container>
          <ng-template #notLastInput>
            <input
              matInput
              class="range-input"
              type="number"
              min="0"
              [(ngModel)]="item.value"
              (ngModelChange)="onMaxValueChange(idx, $event)"
              [ngClass]="{ 'input-error': hasMaxError(idx) }"
            />
          </ng-template>
          <button
            mat-icon-button
            class="button-configurator"
            (click)="showShapeContainer[idx] = !showShapeContainer[idx]"
          >
            <wlm-icon icon="tune"></wlm-icon>
          </button>

          <ng-container
            *ngIf="idx !== model.styleDefinition.rangeDefinition.length - 1; else emptyAddButton"
          >
            <button mat-icon-button class="button-configurator" (click)="addRangeDefinition(idx)">
              <wlm-icon icon="add"></wlm-icon>
            </button>
          </ng-container>
          <ng-template #emptyAddButton>
            <button mat-icon-button class="button-configurator" disabled></button>
          </ng-template>
          <ng-container
            *ngIf="
              model.styleDefinition.rangeDefinition.length >= 3 &&
                idx !== 0 &&
                idx !== model.styleDefinition.rangeDefinition.length - 1;
              else emptyButton
            "
          >
            <button
              mat-icon-button
              class="button-configurator"
              (click)="deleteRangeDefinition(idx); $event.stopPropagation()"
              onclick="this.blur()"
            >
              <wlm-icon icon="delete"></wlm-icon>
            </button>
          </ng-container>
          <ng-template #emptyButton>
            <button mat-icon-button class="button-configurator" disabled></button>
          </ng-template>
        </div>
        <ng-container *ngIf="layerType === 'Point'">
          <div
            class="color-picker-container"
            *ngIf="showShapeContainer[idx]"
            [ngClass]="{
              'no-margin-bottom': idx === model.styleDefinition.rangeDefinition.length - 1
            }"
          >
            <div class="color-picker-wrapper">
              <label class="label-container shapes-label">{{ 'Color' }}</label>
              <div
                class="mini-color-picker"
                [colorPicker]="controlsData[idx]?.Color"
                (colorPickerChange)="onColorPickerChange($event, idx)"
                [style.background]="controlsData[idx]?.Color"
                cpPosition="right"
                [cpWidth]="cpCustomizableWidth"
                [cpHeight]="cpCustomizableHeight"
                id="colorPickerDiv"
              ></div>
            </div>

            <div class="slider-container range-slider-magin">
              <wlm-timeline-slider
                [title]="T_SCOPE + '.size' | translate"
                [initialValue]="
                  model.styleDefinition.rangeDefinition[idx].styleDefinition.definition.Size
                "
                (initialValueChange)="onSizeChange(idx, $event)"
              ></wlm-timeline-slider>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="layerType === 'Line'">
          <div
            class="color-picker-container"
            *ngIf="showShapeContainer[idx]"
            [ngClass]="{
              'no-margin-bottom': idx === model.styleDefinition.rangeDefinition.length - 1
            }"
          >
            <div class="color-picker-wrapper">
              <label class="label-container shapes-label">{{ 'Color' }}</label>
              <div
                class="mini-color-picker"
                [colorPicker]="controlsData[idx]?.Color"
                (colorPickerChange)="onColorPickerChange($event, idx)"
                [style.background]="controlsData[idx]?.Color"
                cpPosition="right"
                [cpWidth]="cpCustomizableWidth"
                [cpHeight]="cpCustomizableHeight"
                id="colorPickerDiv"
              ></div>
            </div>

            <div class="slider-container range-slider-magin">
              <wlm-timeline-slider
                [title]="T_SCOPE + '.size' | translate"
                [initialValue]="
                  model.styleDefinition.rangeDefinition[idx].styleDefinition.definition.Size
                "
                (initialValueChange)="onSizeChange(idx, $event)"
              ></wlm-timeline-slider>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="layerType === 'Polygon'">
          <div
            class="color-picker-container"
            *ngIf="showShapeContainer[idx]"
            [ngClass]="{
              'no-margin-bottom': idx === model.styleDefinition.rangeDefinition.length - 1
            }"
          >
            <div class="color-picker-wrapper">
              <label class="label-container shapes-label">{{ 'Color' }}</label>
              <div
                class="mini-color-picker"
                [colorPicker]="controlsData[idx]?.Color"
                (colorPickerChange)="onColorPickerChange($event, idx)"
                [style.background]="controlsData[idx]?.Color"
                cpPosition="right"
                [cpWidth]="cpCustomizableWidth"
                [cpHeight]="cpCustomizableHeight"
                id="colorPickerDiv"
              ></div>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <div class="slider-container opacity-container">
        <wlm-timeline-slider
          [title]="T_SCOPE + '.opacity' | translate"
          [initialValue]="currentOpacity"
          (initialValueChange)="onOpacityChange($event)"
        ></wlm-timeline-slider>
      </div>
    </div>
  </ng-container>
  <ng-container popup-actions>
    <button
      mat-raised-button
      class="wtr-action-button-primary"
      style="width: 100%"
      [disabled]="!allValid"
      (click)="onSave()"
      onclick="this.blur()"
    >
      {{ 'common.save' | translate }}
    </button>
  </ng-container>
</wlm-map-popup-wrapper>
